/**
 * IE11 fix as it doesn't allow [].flat()
 *
 * @param array
 * @returns array
 */
exports.flatArray = function(array) {
  return [].concat.apply([], array);
};
